import React from 'react'
import { Modal, Button, List, Icon, Alert } from 'antd'
import { ImagePreview } from '../../../../../components'

const ImageHistoryModal = ({ visible, history, onCancel, onSelect }) => {
  const handleSelectImage = image => {
    Modal.confirm({
      title: 'Restore this version?',
      content:
        'This will replace your current shot image with this historical version.',
      okText: 'Yes, Restore',
      cancelText: 'Cancel',
      centered: true,
      icon: <Icon type="exclamation-circle" />,
      onOk() {
        onSelect(image.url)
      }
    })
  }

  const reversedHistory = history.slice().reverse()

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: 18, fontWeight: 600, color: '#1f1f1f' }}>
            Version History
          </span>
          <span
            style={{
              background: '#f0f0f0',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: 12,
              color: '#595959',
              fontWeight: 500
            }}
          >
            {history.length} versions
          </span>
        </div>
      }
      visible={visible}
      centered
      onCancel={onCancel}
      footer={null}
      width={720}
      bodyStyle={{
        padding: '0',
        background: '#fafafa',
        maxHeight: '75vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{ padding: '24px 24px 0 24px' }}>
        <Alert
          message={
            <span style={{ fontWeight: 500 }}>Restore Previous Versions</span>
          }
          description="Browse through your previously generated images. Click 'Restore' to revert the shot to a specific historical version."
          type="info"
          showIcon
          style={{
            border: '1px solid #e6f7ff',
            background: '#e6f7ff',
            borderRadius: '8px'
          }}
        />
      </div>

      <div style={{ padding: '24px', overflowY: 'auto' }}>
        <List
          itemLayout="horizontal"
          className="image-history-list"
          dataSource={reversedHistory}
          split={false}
          renderItem={(item, index) => {
            const versionNumber = history.length - index
            const isLatest = index === 0

            return (
              <List.Item
                style={{
                  background: '#fff',
                  borderRadius: '12px',
                  marginBottom: '16px',
                  padding: '0',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  border: '1px solid #f0f0f0',
                  overflow: 'hidden'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    padding: '16px',
                    gap: '20px',
                    alignItems: 'center'
                  }}
                >
                  {/* Thumbnail Section */}
                  <div
                    style={{
                      width: 180,
                      height: 100,
                      borderRadius: '8px',
                      background: '#f0f2f5',
                      position: 'relative',
                      flexShrink: 0,
                      overflow: 'hidden',
                      border: '1px solid #eee'
                    }}
                  >
                    <ImagePreview
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                      src={item.url}
                      alt={`History ${index}`}
                    />

                    {/* Eye Icon Overlay */}
                    {/* <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '40px',
                        height: '40px',
                        background: 'rgba(0, 0, 0, 0.4)',
                        backdropFilter: 'blur(4px)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        border: '1px solid rgba(255,255,255,0.3)',
                        pointerEvents: 'none', // Allow click to pass through to ImagePreview if it handles click
                        zIndex: 10
                      }}
                    >
                      <Icon type="eye" style={{ fontSize: 20 }} />
                    </div> */}
                  </div>

                  {/* Metadata Section */}
                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      minWidth: 0
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 6
                      }}
                    >
                      <h4
                        style={{
                          margin: 0,
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#1f1f1f'
                        }}
                      >
                        Version {versionNumber}
                      </h4>
                      {isLatest && (
                        <span
                          style={{
                            marginLeft: 8,
                            background: '#e6f7ff',
                            color: '#1890ff',
                            fontSize: '11px',
                            fontWeight: 600,
                            padding: '1px 8px',
                            borderRadius: '10px',
                            textTransform: 'uppercase',
                            border: '1px solid #91d5ff'
                          }}
                        >
                          Latest
                        </span>
                      )}
                    </div>

                    <div
                      style={{
                        color: '#8c8c8c',
                        fontSize: '13px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        marginBottom: '12px'
                      }}
                    >
                      {item.timestamp ? (
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          <Icon
                            type="clock-circle"
                            style={{ marginRight: 6, fontSize: 13 }}
                          />
                          {new Date(item.timestamp).toLocaleDateString(
                            undefined,
                            {
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric'
                            }
                          )}
                          <span style={{ margin: '0 4px', color: '#d9d9d9' }}>
                            |
                          </span>
                          {new Date(item.timestamp).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                      ) : (
                        <span>No timestamp</span>
                      )}
                    </div>
                  </div>

                  {/* Actions Section */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '8px',
                      marginLeft: 'auto'
                    }}
                  >
                    <Button
                      type="primary"
                      ghost
                      icon="rollback"
                      style={{
                        minWidth: '90px',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: 500
                      }}
                      onClick={() => handleSelectImage(item)}
                    >
                      Restore
                    </Button>
                  </div>
                </div>
              </List.Item>
            )
          }}
        />
      </div>
    </Modal>
  )
}

export default ImageHistoryModal
